import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlunosModel } from '../../alunos/alunos.model';
import { BloquearProfessor } from '../../models/bloquear-professor';
import { MarcarQuestao } from '../../models/marcar-questao';
import { ProfessorModel } from '../../models/professor.model';
import { QuesitosModel, QuesitosModelRequest, QuestionarioModel } from '../../models/questionario.model';
import { ProfessorService } from '../../services/professor.service';
import { QuestionarioService } from '../../services/questionario.service';
import { ComentariosService } from '../../services/comentarios.service';
import { isNil } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';

export interface QuesitoSelecionado {
  quesitoIndex: number;
  hashQuesito: string;
  hashOpcao: string;
  hashProfessor: string;
  hashPessoa: string;
}

@Component({
  selector: 'app-questoes',
  templateUrl: './questoes.component.html',
  styleUrls: ['./questoes.component.scss'],
})

export class QuestoesComponent implements OnInit {
  constructor(
    private questionarioService: QuestionarioService,
    public professorService: ProfessorService,
    private comentarioService: ComentariosService,
    private location: Location,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.salvando = false;
    this.formularioFeedback.emit(false);
    this.comentarioProfessor = "";
  }

  private _questoes: QuestionarioModel;
  @Input() set questoes(value: QuestionarioModel) {
    this._questoes = value;
    this._questoes.quesitos.forEach(f => f.opcoes = f.opcoes.sort((a, b) => a.legenda.localeCompare(b.legenda)))
    this.concluido = true;
    this.Initialize(true);
  }
  get questoes() {
    return this._questoes;
  }

  @Input() professor: ProfessorModel;

  @Input() quantidadeProfessores: number;

  @Input() indexProfessorAtual: number;

  @Input() aluno: AlunosModel;

  @Output() pularProfessor = new EventEmitter<ProfessorModel>();

  @Output() bloquearProfessorNaoPossuiAula = new EventEmitter<BloquearProfessor>();
  @Output() bloquearProfessorNaoSabeAvaliar = new EventEmitter<BloquearProfessor>();

  @Output() questaoSelecionadaEmiter = new EventEmitter<MarcarQuestao>();

  @Output() comentario = new EventEmitter<boolean>();

  @Output() comentarioFeedback = new EventEmitter();


  bloquearQuestionario = false;

  questaoSelecionada: QuesitosModel;

  indexSelecionado = 0;

  arrowRight = true;

  porcentagemSelecionadas = 0;

  counter = 0;

  imageError = false;

  enviarResposta: boolean = true;

  comentarioProfessor: string = "";


  @Input() reavaliado: boolean = false;
  @Output() reavaliacaoRequest = new EventEmitter<boolean>();
  @Output() exibirListaProfessoresRequest = new EventEmitter<boolean>();
  @Output() formularioFeedback = new EventEmitter<boolean>();



  salvando = false;

  Initialize(start: boolean = false): void {

    this.reavaliado = true

    const ultimaQuestaoRespondida = this.questoes.quesitos.filter(
      q => q.hashOpcaoSelecionada === null
    )[0];

    let index;

    if (!this.reavaliado) {
      index = this.questoes.quesitos.indexOf(ultimaQuestaoRespondida);

      if (index >= 0) {
        this.selecionarQuestao(index);
      }
    }
    else {

      if (this.questoes.quesitos.length - 1 == this.indexSelecionado) {
        this.reavaliacaoRequest.emit(true);
      }

      index = this.questoes.quesitos.length - 1 == this.indexSelecionado
        ? this.indexSelecionado
        : this.indexSelecionado + 1;

      if(start)
        index = 0;
    }

    this.getPorcentagemRespondidos();

    if (this.porcentagemSelecionadas == 100 && start) {
      this.concluido = true;
    }

    if (index >= 0 || start) {
      this.selecionarQuestao(index !== -1 ? index : 0);
    }

    if (start && this.reavaliado) {
      this.reavaliarSelecionartRespostas();
    }

  }

  emitProfessor() {
    setTimeout(() => {                           // <<<---using ()=> syntax
      this.pularProfessor.emit(this.professor);
    }, 1000);
  }

  emitComentario() {
    this.comentario.emit(true);
  }

  emitQuestaoSelecionada(quantidadeRespondida: number) {
    const obj: MarcarQuestao = {
      index: this.indexProfessorAtual,
      respondidas: quantidadeRespondida,
      status: true,
    };
    this.questaoSelecionadaEmiter.emit(obj);
  }

  reavaliar() {
    this.reavaliacaoRequest.emit(true)
    this.selecionarQuestao(0);
    this.reavaliado = true;
  }

  feedback() {
    this.reavaliacaoRequest.emit(false)
  }


  reavaliarSelecionartRespostas() {
    this.questoesQuesitosSelecionados = [];
    this.reavaliacaoRequest.emit(true)
    this.reavaliado = true;

    const hashs = this.questoes.quesitos.filter(el => el.hashOpcaoSelecionada != null).map((quesito, index) => {
      return {
        indexQuesito: index,
        hashQuesito: quesito?.id,
        hashOpcao: quesito.hashOpcaoSelecionada,
        hashProfessor: this.professor?.id
      };
    });
    this.questoesQuesitosSelecionados = hashs;
  }
  

  selecionarQuestao(index: number) {
    this.questoes.quesitos.map(q => q.selected = false);

    if (!this.questoes.quesitos[this.questoes.quesitos.length - 1].avaliado)
      this.questoes.quesitos[index].avaliado = false;

    const questao = this.questoes.quesitos[index];

    if (index === this.questoes.quesitos.length - 1)
      this.arrowRight = false;
    else
      this.arrowRight = true;

    questao.selected = true;

    this.indexSelecionado = index;

    this.questaoSelecionada = questao;

  }

  desmarcarQuestaoSelecionada(index: number) {
    const questao = this.questoes.quesitos[index];
    questao.opcoes.map(x => x.selected = false);

    this.questaoSelecionada = questao;
  }

  questoesQuesitosSelecionados: any[] = [];
  selecionarOpcaoArray(index: number, quesitoIndex: number) {
    const hashQuesito = this.questaoSelecionada.id;
    const hashOpcao = this.questoes.quesitos[quesitoIndex].opcoes[index].hash;
    const hashProfessor = this.professor.id;
    const hashPessoa = this.aluno.hashPessoa;
    const indexQuesito = quesitoIndex

    const hashs = {
      indexQuesito,
      hashQuesito,
      hashOpcao,
      hashProfessor,
      hashPessoa,
    };

    const indexExistente = this.questoesQuesitosSelecionados.findIndex(item => item.indexQuesito === indexQuesito);

    if (indexExistente !== -1)
      this.questoesQuesitosSelecionados.splice(indexExistente, 1);

    this.questoesQuesitosSelecionados.push(hashs);

    const questoes = this.questoes;
    this.counter = this.professor.questoes;

    questoes.dataUltimaResposta = this.dataAtualFormat();

    const opcao = this.questoes
      .quesitos[quesitoIndex]
      .opcoes[index];

    if (!opcao) {
      questoes
        .quesitos[quesitoIndex]
        .hashOpcaoSelecionada = null;

      return;
    }

    questoes
      .quesitos[quesitoIndex]
      .hashOpcaoSelecionada = opcao.hash;

      setTimeout(() => {
        this.Initialize();
      },250)
  }

  capturarComentario(texto: string) {
    this.comentarioProfessor = texto;
    this.professor.comentario = texto;
  }

  backSalvar() {
      this.location.back();
  }

  loadingButtonSalvar: boolean = false;
  contador = 0;
  salvarAvaliacao() {
    const qtdSalvar = this.questoesQuesitosSelecionados.length;

    if(this.questoesQuesitosSelecionados && qtdSalvar < this.questoes.quesitos.length){
      this.toastr.error('Para enviar, é preciso avaliar todos os quesitos',
      null,
      {
          closeButton: true,
          disableTimeOut: false
      });

      return;
    }

    this.loadingButtonSalvar = true;

    if (this.reavaliado) {

      this.questoesQuesitosSelecionados = this.questoesQuesitosSelecionados.map(f =>
        Object.assign(f, {
          hashPessoa: this.aluno.hashPessoa,
          hashProfessor: this.professor.id
        })
      );

    }

    const hashProfessor = this.professor.id;
    const hashPessoa = this.aluno.hashPessoa;
    const respostaQuesitos: any[] = this.questoesQuesitosSelecionados;
    const comentarioProfessor = this.refezComentario? this.professor.comentario : this.comentarioProfessor;

    const hashs: QuesitosModelRequest = {
      respostaQuesitos,
      hashProfessor,
      hashPessoa,
      comentarioProfessor
    };

    this.questionarioService.salvarOpcoesComentario(hashs).subscribe(
      saves => {
        this.loadingButtonSalvar = false;
        const questoes = this.questoes;
        this.counter = this.professor.questoes;
        questoes.dataUltimaResposta = saves.dataUltimaResposta;
        this.salvando = false;
        this.formularioFeedback.emit(true);
        this.emitProfessor();
        this.backSalvar();
      },
      el => {
        this.salvando = false;
        this.loadingButtonSalvar = false;
      }
    );

    /*
    const observables = this.questoesQuesitosSelecionados.map(item => {
      const avaliacao = {
        hashQuesito: item.hashQuesito,
        hashOpcao: item.hashOpcao,
        hashProfessor: item.hashProfessor,
        hashPessoa: item.hashPessoa,
      };

      this.salvando = true;

      this.questionarioService.salvarOpcao(avaliacao).subscribe(
        saves => {

          const questoes = this.questoes;
          this.counter = this.professor.questoes;
          questoes.dataUltimaResposta = saves.dataUltimaResposta;
          //this.Initialize();
          this.contador++;

          //this.concluido = true;
          if(this.contador == qtdSalvar){
            this.salvando = false;

            if (!isNil(this.comentarioProfessor))
              this.salvarComentario();

            this.formularioFeedback.emit(true);
            this. emitProfessor();
          }
          this.salvando = false;

        },
        el => {
          console.log(el)
          this.salvando = false;
        }
      );

    });

    */
  }

  salvarAvaliacaoAdicional() {

    const qtdSalvar = this.questoesQuesitosSelecionados.length;

    if(this.questoesQuesitosSelecionados && qtdSalvar < this.questoes.quesitos.length){
      this.toastr.error('Para enviar, é preciso avaliar todos os quesitos',
      null,
      {
          closeButton: true,
          disableTimeOut: false
      });
      return;
    }

    this.loadingButtonSalvar = true;
debugger;
    const hashProfessor = this.professor.id;
    const hashPessoa = this.aluno.hashPessoa;
    const hashPOAAluno = this.aluno.poaAlunoHash;
    const comentario = this.refezComentario? this.professor.comentario : this.comentarioProfessor;

    let quesitos = this.questoesQuesitosSelecionados.map(el => ({ hashQuesito: el.hashQuesito, hashOpcao: el.hashOpcao }))
    var request = {
      hashPessoa: hashPessoa,
      hashPOAAluno: hashPOAAluno,
      hashPessoaAdicional: hashProfessor,
      quesitos: quesitos,
      comentario: comentario
    }

    // this.salvando = true;

    this.questionarioService.salvarOpcaoAdicional(request)
      .subscribe(result => {
        this.salvando = false;
        this.counter = this.professor.questoes;
        this.formularioFeedback.emit(true);
        this.emitProfessor();
        this.backSalvar();
        this.loadingButtonSalvar = false;
      }, error => {
        this.salvando = false;
        this.loadingButtonSalvar = false;
      })
  }


  salvarComentario() {
    const comentarioProfessor = this.comentarioProfessor;
    const hashProfessor = this.professor.id;
    const hashPessoa = this.aluno.hashPessoa;

    const hashs = {
      hashProfessor,
      hashPessoa,
      comentarioProfessor,
    };

    if (!isNil(this.comentarioProfessor)) {

      this.comentarioService
        .salvarComentario(hashs)
        .subscribe(
          () => {
            hashs['comentariosend'] = true;
            this.comentarioFeedback.emit(hashs);
          }
        );
    }

  }

  selecionarOpcao(index: number, quesitoIndex: number) {
    if (this.salvando)
      return;

    this.salvando = true;

    const hashQuesito = this.questaoSelecionada.id;
    const hashOpcao = this.questoes.quesitos[quesitoIndex].opcoes[index].hash;
    const hashProfessor = this.professor.id;
    const hashPessoa = this.aluno.hashPessoa;

    const hashs = {
      hashQuesito,
      hashOpcao,
      hashProfessor,
      hashPessoa,
    };

    const questoes = this.questoes;

    this.counter = this.professor.questoes;

    this.questionarioService.salvarOpcao(hashs)
      .subscribe(
        saves => {
          this.salvando = false;

          questoes.dataUltimaResposta = saves.dataUltimaResposta; /// Set data from last question awnsered

          const opcao = this.questoes
            .quesitos[quesitoIndex]
            .opcoes[index];

          if (!opcao) {
            questoes
              .quesitos[quesitoIndex]
              .hashOpcaoSelecionada = null;

            return;
          }

          questoes
            .quesitos[quesitoIndex]
            .hashOpcaoSelecionada = opcao.hash;

          this.Initialize();
        },
        el => {
          this.salvando = false;
        });
  }

  naoPossuiAulaProfessor(event: boolean) {
    const hashQuesito = this.questaoSelecionada.id;
    const hashProfessor = this.professor.id;
    const hashPessoa = this.aluno.hashPessoa;

    const hashs = {
      hashQuesito,
      hashProfessor,
      hashPessoa,
    };

    const emit: BloquearProfessor = {
      index: this.indexProfessorAtual,
      checked: event,
    };

    this.questoes.naoPossuiAulaComProfessor = event;

    this.questionarioService
      .SaveSemAula(hashs, event)
      .subscribe(() => {
        this.bloquearProfessorNaoPossuiAula.emit(emit);
        this.Initialize();
      });
  }

  // naoSabeAvaliarProfessor(checked: boolean, sendToComment: boolean = false) {
  //   const hashQuesito = this.questaoSelecionada.id;
  //   const hashProfessor = this.professor.id;
  //   const hashPessoa = this.aluno.hashPessoa;

  //   const hashs = {
  //     hashQuesito,
  //     hashProfessor,
  //     hashPessoa,
  //   };

  //   const emit: BloquearProfessor = {
  //     index: this.indexProfessorAtual,
  //     checked,
  //   };

  //   this.questoes.naoSabeAvaliarProfessor = checked;

  //   this.questionarioService
  //     .PrefereNaoResponder(hashs, checked)
  //     .subscribe(() => {
  //       this.bloquearProfessorNaoSabeAvaliar.emit(emit);
  //       this.Initialize();
  //       if (sendToComment)
  //         this.emitComentario();
  //     });

  // }

  porcentagemParteTotal(total: number, parte: number): number {
    return (parte * 100) / total;
  }

  concluido: boolean = true;

  getPorcentagemRespondidos() {
    const questoes = this.questoes.quesitos.filter(q => q.hashOpcaoSelecionada);

    setTimeout(() => this.emitQuestaoSelecionada(questoes.length), 1000);

    this.porcentagemSelecionadas = this.porcentagemParteTotal(
      this.questoes.quesitos.length,
      questoes.length
    );

    this.concluido = this.reavaliado ? true : false;
  }

  /* Funcs */
  opcaoOrder(arrayObj: any, orderby: string = 'ASC'): any[] {
    return arrayObj.sort(function (objA: any, objB: any) {

      var a = objA.legenda.toLowerCase().replace(/[àáâãäå]/, "a").replace(/[èéêë]/, "e").replace(/[ìíîï]/, "i").replace(/[òóôõö]/, "o").replace(/[ùúûü]/, "u").replace(/[ç]/, "c").replace(/[^a-z0-9]/gi, '')
      var b = objB.legenda.toLowerCase().replace(/[àáâãäå]/, "a").replace(/[èéêë]/, "e").replace(/[ìíîï]/, "i").replace(/[òóôõö]/, "o").replace(/[ùúûü]/, "u").replace(/[ç]/, "c").replace(/[^a-z0-9]/gi, '')

      if (orderby == 'ASC') {
        return a < b ? -1 : a > b ? 1 : 0;
      }
      else { //return a < b ? 1 : a > b ? -1 : 0
        if (a < b) {
          return 1;
        }
        else if (a > b) {
          return -1;
        } else {
          return 0;
        }
      }

    })
  }

  respostaEnviada() {
    this.concluido = true;
  }

  reciverFeedback(hashs) {
    hashs['index'] = this.indexProfessorAtual;
    this.comentarioFeedback.emit(hashs);
    if (hashs['comentariosend'])
      this.porcentagemSelecionadas = 100;
  }

  refezComentario: boolean = false;
  reavaliadoFeedback(bool : boolean) {
    this.refezComentario = bool;
    this.reavaliado = false;
  }

  exibirListaProfessores() {
    this.exibirListaProfessoresRequest.emit(true);
  }

  dataAtualFormat() {
    const dataAtual = new Date();

    const zeroPad = (value: number) => {
      return value.toString().padStart(2, '0');
    };

    const ano = dataAtual.getFullYear();
    const mes = zeroPad(dataAtual.getMonth() + 1);
    const dia = zeroPad(dataAtual.getDate());
    const hora = zeroPad(dataAtual.getHours());
    const minuto = zeroPad(dataAtual.getMinutes());
    const segundo = zeroPad(dataAtual.getSeconds());
    const milissegundo = dataAtual.getMilliseconds();

    const dataFormatada = `${ano}-${mes}-${dia}T${hora}:${minuto}:${segundo}.${milissegundo.toString().padStart(6, '0')}`;

    return dataFormatada;
  }

  cancelar() {

    if(!this.reavaliado){
      const obj: MarcarQuestao = {
        index: this.indexProfessorAtual,
        respondidas: 0,
        status: false,
      };

      this.professor.questoes = 0;

      for (let index = 0; index < this.questoes.quesitos.length; index++) {
        this.professor.quesitos[index].hashOpcaoSelecionada = null;
      }

      this.getPorcentagemRespondidos();
    }

    this.exibirListaProfessoresRequest.emit(true);
  }

}
